export default "__VITE_ASSET__BoS_sBFB__"